// 공통 리스트 파라미터 타입
export interface IListParams extends Record<string, string | number> {
    page: number;
    searchtxt: string;
}

// 게시판 리스트 파라미터 타입
export interface IBoardListParams extends IListParams {
    listSize: number;
    search: string;
}

// 팝업 리스트 파라미터 타입
export interface IPopupListParams extends IListParams {
    type: string;
}

// 리스트 검색 타입
export const listSearchTypes = [
    { value: "title", label: "제목만" },
    { value: "titlecontents", label: "제목+내용" },
    { value: "name", label: "작성자" },
];

// 리스트 페이지 크기 옵션
export const listSizes = [10, 20, 30, 50];

// 팝업 타입
export const popupTypes = ["P", "M"];
